<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title title="编辑基因实验室检测平台"></pt-page-title>
    <pt-lab-test-platform-form ref="child" :isEdit="true"  @upateLoading="upateLoading"></pt-lab-test-platform-form>
    <div class="marginTop">
    <el-button type="primary" @click="edit">保存</el-button>
    <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import ptLabTestPlatformForm from '../pt-lab-test-platform-form/withData'
// 组件class前缀
const prefixCls = 'pt-lab-test-platform-update'

export default {
  name: 'pt-lab-test-platform-update',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptLabTestPlatformForm
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    edit () {
      this.$refs.child.edit()
      // .then(() => {
      //   this.$message.success('新建成功!')
      //   this.$router.push({ name: 'product-list', params: { type: this.type } })
      //   this.loading = false
      // }).catch((error) => {
      //   console.error(error)
      //   this.loading = false
      //   this.$message.error('新建产品失败！' + error)
      // })
    },
    cancel () {
      history.go(-1)
    },
    upateLoading (val) {
      this.loading = val
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
